<template>
  <Card
    :border="false"
    class="z-20 w-full px-4 py-2 ring-2"
    :class="{
      'bg-red-200 ring-red-500': message.messageType === 'error',
      'bg-blue-200 ring-purple-600': message.messageType === 'info',
      'bg-green-200 ring-green-500': message.messageType === 'success',
    }"
  >
    <h2
      v-if="message.header"
      class="text-lg font-bold"
      :class="{
        'text-red-800': message.messageType === 'error',
        'text-purple-800': message.messageType === 'info',
        'text-green-800': message.messageType === 'success',
      }"
    >
      {{ message.header }}
    </h2>

    <p
      v-if="message.text"
      :class="{
        'text-red-700': message.messageType === 'error',
        'text-purple-800': message.messageType === 'info',
        'text-green-700': message.messageType === 'success',
      }"
    >
      {{ message.text }}
    </p>
    <div v-if="message.linkName" class="mt-2 flex flex-row">
      <RouterLink
        v-if="!message.linkName.startsWith('mailto:')"
        class="btn-primary"
        :to="{ name: message.linkName }"
      >
        {{ message.linkText }}
      </RouterLink>

      <a v-else :href="message.linkName" class="inline-link" target="_blank">
        {{ message.linkText }}
      </a>
    </div>
  </Card>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import { MessageContent } from "@/components/Forms/messages";
import Card from "@/components/Core/Card.vue";

defineProps({
  message: {
    type: Object as PropType<MessageContent>,
    required: true,
  },
});
</script>
